import axios from "axios";

export const getRaCheckInCheckOut = async (params: {id: string, outin: string}): Promise<any> => {
    const response = await axios.get(`/network/ra/${params.id}/checkoutin/${params.outin}?isCheckOutIn=0`);
    return response.data;
};
